'use strict';
angular.module('manuscriptAssociationModule', []).controller('manuscriptAssociationCtrl', ['$scope', '$sce', '$q', '$modal', '$timeout', '$state', '$location', '$window', '$filter', 'trsHttpService', '$stateParams', 'editcenterRightsService', 'modalDialog', 'editingCenterService', 'localStorageService', 'initSingleSelecet', 'appQuickSignService', 'messagePublishService',
    function($scope, $sce, $q, $modal, $timeout, $state, $location, $window, $filter, trsHttpService, $stateParams, editcenterRightsService, modalDialog, editingCenterService, localStorageService, initSingleSelecet, appQuickSignService, messagePublishService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.status = {
                copyCurrPage: 1,
            };
            $scope.keywords = '';
            $scope.params = {
                serviceid: 'mlf_appquicksign',
                methodname: 'querySelectedChannelDetail',
                SearchWord: '',
                SiteId: $stateParams.siteid,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                StartTime: '',
                EndTime: '',
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]null
         */
        function initData() {
            requestData();
            $scope.data.timeTypeArray = initSingleSelecet.chooseTimeType();
            $scope.data.selectedTimeType = angular.copy($scope.data.timeTypeArray[0]);
        }

        /**
         * [fullTextSearch description;全文检索]
         *  @param  {[type]} ev [description]
         * @return  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                $scope.params.SearchWord = $scope.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.data.selectedArray = [];
            var params = $scope.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }


        /**
         * [create description]新建关联
         * @return {[type]} [description]
         */
        $scope.create = function() {
            appQuickSignService.openNewRelation('新建', undefined, function(success) {
                if (success.ISSUCCESS === 'true') {
                    requestData();
                }
            });
        };

        /**
         * [plDelete description]批量删除
         * @return {[type]} [description]
         */
        $scope.plDelete = function() {
            var params = {
                serviceid: 'mlf_appquicksign',
                methodname: 'deleteMultiQuickSignRelation',
                ChannelIds: getChannelIds(),
            };
            modalDialog.alertType('', '是否确认删除关联？?', 'ask', true, function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function() {
                    modalDialog.alertType('删除关联成功', '', 'success', false, function() {
                        requestData();
                        messagePublishService.publish('refreshList', true);
                    });
                });
            });
        };

        /**
         * [edit description] 编辑
         *  @param  {[type]} item [description]
         * @return {[type]} [description]
         */
        $scope.edit = function(item) {
            appQuickSignService.openNewRelation('编辑', item, function(success) {
                if (success.ISSUCCESS === 'true') {
                    requestData();
                }
            });
        };

        /**
         * [Delete description] 删除
         *  @param  {[type]} item [description]
         * @return {[type]} [description]
         */
        $scope.delete = function(item) {
            var params = {
                serviceid: 'mlf_appquicksign',
                methodname: 'deleteMultiQuickSignRelation',
                ChannelIds: item.CHANNELID,
            };
            modalDialog.alertType('', '是否确认删除关联？', 'ask', true, function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function() {
                    modalDialog.alertType('删除关联成功', '', 'success', false, function() {
                        requestData();
                        messagePublishService.publish('refreshList', true);
                    });
                });
            });
        };

        /**
         * [singleSelect description] 单选
         *  @param  {[type]} item [description]
         * @return {[type]} [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [selectAll description] 单选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length === $scope.data.items.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.items);
            }
        };

        /**
         * [getChannelIds description]
         * @return {[type]} [description]
         */
        function getChannelIds() {
            return $scope.data.selectedArray.reduce((pre, item, index, arr) => index === arr.length - 1 ? pre + item.CHANNELID : pre + item.CHANNELID + ',', '');
        }

        /**
         * [queryDropDown description] 根据时间筛选
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.queryDropDown = function(key, value) {
            $scope.params[key] = value;
            $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            if (key === 'timeType') {
                $scope.params.StartTime = $scope.data.fromdate;
                $scope.params.EndTime = $scope.data.untildate;
                $scope.params[key] = null;
            }
            requestData();
        };

        // 分页
        $scope.pageChanged = function() {
            requestData();
        };

        // 跳转
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.CurrPage = $scope.status.copyCurrPage;
            requestData();
        };

        // 每页展示
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };
    },
]);
